module.exports = __webpack_public_path__ + "img/yuyuko saigyouji_sc1.adc1e00d.png";